import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "reduced-amount" }

import { IonItem, IonItemOptions, IonItemSliding, IonRippleEffect, useKeyboard } from "@ionic/vue";
import { ref } from "vue";

import { ButtonSlidingProps } from "@/types/props";


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonSliding',
  props: {
    disabled: { type: Boolean },
    itemButton: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {



const { isOpen } = useKeyboard()

const slidingItem = ref()

const closeItem = async (event: any): Promise<void> => {
    if (event.target.tagName !== 'ION-ITEM-OPTIONS') return;
    slidingItem.value.$el.close()
}

__expose({
    slidingItem,
    open: (direction?: 'start' | 'end') => slidingItem.value.$el.open(direction),
    close: () => slidingItem.value.$el.close()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItemSliding), {
    ref_key: "slidingItem",
    ref: slidingItem,
    class: "card-border",
    disabled: __props.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (closeItem($event)))
  }, {
    default: _withCtx(() => [
      (_ctx.$slots['options-start'])
        ? (_openBlock(), _createBlock(_unref(IonItemOptions), {
            key: 0,
            side: "start",
            class: "button-options options-start"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "options-start")
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "item", {}, () => [
        _createVNode(_unref(IonItem), {
          class: _normalizeClass(["no-dimensions max-height native-max", {'ion-activatable card-ripple-parent': __props.itemButton}]),
          lines: "none"
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default"),
            (__props.itemButton && !_unref(isOpen))
              ? (_openBlock(), _createBlock(_unref(IonRippleEffect), { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["class"]),
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "reduced-amount")
        ])
      ]),
      (_ctx.$slots['options-end'])
        ? (_openBlock(), _createBlock(_unref(IonItemOptions), {
            key: 1,
            side: "end",
            class: "button-options options-end"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "options-end")
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["disabled"]))
}
}

})